import React from 'react';
import { Link } from 'react-router-dom';

import logo from 'assets/img/logo.svg';
import logoMobile from 'assets/img/logo-mobile.svg';

import Cover from 'components/Cover';

const Header = ({ className, title, subtitle, img }) => {
  return (
    <header className={className || 'header'}>
      <Cover src={img} isLarge />
      <div className="header__content">
        <h2 className="header__title">{title || 'Meo Passatempos'}</h2>
        <h3 className="header__subtitle">{subtitle || 'Só os verdadeiros fãs podem chegar ao fim'}</h3>
      </div>
      <Link to="/" className="header__logo">
        <picture>
          <source media="(max-width: 620px)" srcSet={logoMobile} />
          <img src={logo} alt="MEO" />
        </picture>
      </Link>
    </header>
  );
};

export default Header;
